<template>
  <div class="mapper-container">
    <gmap-map
      class="gmap-map"
      :center="{ lat: 0, lng: 0 }"
      :zoom="3"
      :options="MapOptions"
    >
      <mapper-overview :status.sync="status" :routes="FilteredRoutes" :locations="FilteredLocations" :hubs="hubs" v-if="status === MapperStatus.Overview"></mapper-overview>
      <create-route :status.sync="status" :routes="FilteredRoutes" :locations="FilteredLocations" :hubs="hubs" v-else-if="status === MapperStatus.CreateRoute"></create-route>
      <add-stop :status.sync="status" :routes="FilteredRoutes" :locations="FilteredLocations" :hubs="hubs" v-else-if="status === MapperStatus.AddStop"></add-stop>
      <optimize-route :status.sync="status" :routes="FilteredRoutes" :locations="FilteredLocations" :hubs="hubs" v-else-if="status === MapperStatus.OptimizeRoute"></optimize-route>
    </gmap-map>

    <div class="toolbar">
      <button class="button is-text" :class="[{ 'is-selected': showLegend }, { 'is-info': showLegend }]" @click="showLegend = true">
        <span class="icon">
          <fa-icon icon="key"></fa-icon>
        </span>
        <span>Legend</span>
      </button>

      <div class="toolbar-section">
        <div class="dropdown" :class="{ 'is-active': options.route.showMenu }">
          <div class="dropdown-trigger" @click="options.route.showMenu = !options.route.showMenu">
            <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
              <span>Route Options</span>
              <span class="icon is-small">
                <fa-icon icon="angle-down"></fa-icon>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="options.route.visible = !options.route.visible">
                <label>
                  <input type="checkbox" v-model="options.route.visible">
                  &nbsp;
                  <span>Visible</span>
                </label>
              </a>
              <hr class="dropdown-divider">
              <a class="dropdown-item" @click.prevent="options.route.visible ? options.route.active = !options.route.active : undefined">
                <label>
                  <input type="checkbox" v-model="options.route.active" :disabled="!options.route.visible">
                  &nbsp;
                  <span>Show Inprogress Routes</span>
                </label>
              </a>
            </div>
          </div>
        </div>

        <div class="dropdown" :class="{ 'is-active': options.locations.showMenu }">
          <div class="dropdown-trigger" @click="options.locations.showMenu = !options.locations.showMenu">
            <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
              <span>Location Options</span>
              <span class="icon is-small">
                <fa-icon icon="angle-down"></fa-icon>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="options.locations.visible = !options.locations.visible">
                <label>
                  <input type="checkbox" v-model="options.locations.visible">
                  &nbsp;
                  <span>Visible</span>
                </label>
              </a>
              <hr class="dropdown-divider">
              <a class="dropdown-item" @click.prevent="options.locations.onRoute = !options.locations.onRoute">
                <label>
                  <input type="checkbox" v-model="options.locations.onRoute">
                  &nbsp;
                  <span>Show Routed</span>
                </label>
              </a>
              <a class="dropdown-item" @click.prevent="options.locations.locations = !options.locations.locations">
                <label>
                  <input type="checkbox" v-model="options.locations.locations">
                  &nbsp;
                  <span>Show Locations</span>
                </label>
              </a>
              <a class="dropdown-item" @click.prevent="options.locations.requests = !options.locations.requests">
                <label>
                  <input type="checkbox" v-model="options.locations.requests">
                  &nbsp;
                  <span>Show Call ins</span>
                </label>
              </a>
              <a class="dropdown-item" @click.prevent="options.locations.requests ? options.locations.recaptureBags = !options.locations.recaptureBags : undefined">
                <label>
                  <input type="checkbox" v-model="options.locations.recaptureBags" :disabled="!options.locations.requests">
                  &nbsp;
                  <span>Show Recapture Bags</span>
                </label>
              </a>
              <a class="dropdown-item" @click.prevent="options.locations.requests ? options.locations.stockpiles = !options.locations.stockpiles : undefined">
                <label>
                  <input type="checkbox" v-model="options.locations.stockpiles" :disabled="!options.locations.requests">
                  &nbsp;
                  <span>Show Stockpiles</span>
                </label>
              </a>
              <hr class="dropdown-divider">
              <a class="dropdown-item" @click.prevent="showQuery = true; options.locations.showMenu = false;">
                <span>Change Filter</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="toolbar-section" style="margin-left: auto;" v-if="status === MapperStatus.Overview">
        <button class="button is-info" @click="status = MapperStatus.OptimizeRoute">
          <span class="icon">
            <fa-icon icon="pencil-alt"></fa-icon>
          </span>
          <span>Optimize Route</span>
        </button>
        
        <button class="button is-warning" @click="status = MapperStatus.AddStop">
          <span class="icon">
            <fa-icon icon="pencil-alt"></fa-icon>
          </span>
          <span>Add Stop</span>
        </button>

        <button class="button is-success" @click="status = MapperStatus.CreateRoute">
          <span class="icon">
            <fa-icon icon="plus"></fa-icon>
          </span>
          <span>Create Route</span>
        </button>
      </div>

      <div class="toolbar-section" style="margin-left: auto;" v-else>
        <button class="button is-danger" @click="status = MapperStatus.Overview">
          <span class="icon">
            <fa-icon icon="times"></fa-icon>
          </span>
          <span>Cancel</span>
        </button>
      </div>
    </div>

    <!--Mapper Components-->
    <Legend v-if="showLegend" @close="showLegend = false" />

    <!--Query Editor-->
    <Editor v-if="showQuery" @close="showQuery = false" type="PickupLocation" @input="onQueryRun" :query="query" />

    <article class="message is-warning" v-if="showMessage">
      <div class="message-header">
        <p>Warning</p>
        <button class="delete" aria-label="delete" @click="showMessage = false"></button>
      </div>
      <div class="message-body">
        <p v-if="LocationsWithoutPoints.length > 0">
          There are {{ LocationsWithoutPoints.length }} Location(s) in your current query without points.
        </p>
        <p v-if="HubsWithoutPoints.length > 0">
          There are {{ HubsWithoutPoints.length }} Hub(s) in your current query without points.
        </p>
      </div>
    </article>
  </div>
</template>

<script>
import Library from 'library'
import Legend from './Components/Legend.vue'

import MapperOverview from './Views/Overview.vue'
import CreateRoute from './Views/CreateRoute.vue'
import AddStop from './Views/AddStop.vue'
import OptimizeRoute from './Views/OptimizeRoute.vue'

const MapperStatus = {
  Overview: 'Overview',
  CreateRoute: 'CreateRoute',
  AddStop: 'AddStop',
  OptimizeRoute: 'OptimizeRoute'
}

export default {
  name: 'MapperContainer',

  data () {
    return {
      showLegend: false,
      showActiveRoutes: true,
      showQuery: false,

      showMessage: false,

      options: {
        route: {
          showMenu: false,
          visible: true,
          active: true
        },

        locations: {
          showMenu: false,
          visible: true,

          onRoute: false,
          locations: true,
          requests: true,
          stockpiles: true,
          recaptureBags: true
        }
      },

      query: {
        isLogicalUnion: true,
        rules: [
          { propertyName: 'pickupRequests.isClosed', operation: 'Equals', value: false }
        ],
        groups: []
      },

      status: MapperStatus.Overview,
      
      routes: [],
      locations: [],
      // These are Collection Locations
      hubs: []
    }
  },

  async mounted () {
    await this.load()
  },

  methods: {
    async load () {
      const loader = this.$loading.open()
      try {
        const [routes, locations, hubs] = await Promise.all([
          // Load All Routes that are not started, or in progress
          this.$entity.query.all('Route', {
            isLogicalUnion: false,
            rules: [
              { propertyName: 'cancelationReason', operation: 'IsNull' },
              { propertyName: 'end', operation: 'IsNull' }
            ]
          }, ['Stops.ServiceStop', 'Stops.WeighStationStop', 'Stops.FuelStop', 'DepartureSite', 'ReturnSite']),

          // Load all Pickup Locations that need to be serviced and have open Pickup Requests, that are not on a route.
          this.$entity.query.all('PickupLocation', this.query, ['PickupRequests', 'ServiceStops.Stop', 'Dumpsters']),

          // Load all Collection Locations
          this.$entity.query.all('CollectionLocation')
        ])

        this.showMessage = false

        routes.data.forEach(route => {
          route.Stops = route.Stops.sort((a, b) => a.stopNumber > b.stopNumber ? 1 : -1)
        })

        this.routes = routes.data
        this.locations = locations.data
        this.hubs = hubs.data

        if (this.LocationsWithoutPoints.length > 0 || this.HubsWithoutPoints.length > 0) {
          this.showMessage = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    },

    async onQueryRun (query) {
      const loader = this.$loading.open()
      try {
        this.query = query
        const locations = await this.$entity.query.all('PickupLocation', query, ['PickupRequests', 'ServiceStops.Stop', 'Dumpsters'])

        this.showMessage = false
        this.locations = locations.data

        if (this.LocationsWithoutPoints.length > 0 || this.HubsWithoutPoints.length > 0) {
          this.showMessage = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    }
  },

  computed: {
    MapperStatus () {
      return MapperStatus
    },

    MapOptions () {
      return {
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false
      }
    },

    FilteredRoutes () {
      return this.routes.filter(route => {
        if (this.options.route.visible) {
          if (route.start) {
            return this.options.route.active
          } else {
            return true
          }
        } else {
          return false
        }
      })
    },

    FilteredLocations () {
      if (this.options.locations.visible) {
        return this.locations.filter(location => location.point).map((location) => ({
          location: location,
          type: location.PickupRequests.find(request => !request.isClosed) ? 'PickupRequest' : 'PickupLocation',
          entity: location.PickupRequests.find(request => !request.isClosed) || location
        })).filter(location => {
          if (this.options.locations.locations && location.type === 'PickupLocation') {
            if (!this.options.locations.onRoute) {
              if (location.location.ServiceStops.filter(ss => {
                if (ss.cancelationReason) {
                  return false
                }

                if (ss.stop.end) {
                  return false
                }

                return true
              }).length > 0) {
                return false
              }
            }

            return true
          } else if (this.options.locations.requests && location.type === 'PickupRequest') {
            if (!this.options.locations.onRoute) {
              if (location.location.ServiceStops.filter(ss => {
                if (ss.cancelationReason) {
                  return false
                }

                if (ss.stop.end) {
                  return false
                }

                return true
              }).length > 0) {
                return false
              }
            }

            if (!this.options.locations.stockpiles && location.entity.isStockpile) {
              return false
            }

            if (!this.options.locations.recaptureBags && location.entity.isRecaptureBag) {
              return false
            }

            return true
          }

          return false
        })
      } else {
        return []
      }
    },

    LocationsWithoutPoints () {
      return this.locations.filter(location => !location.point)
    },

    HubsWithoutPoints () {
      return this.hubs.filter(hub => !hub.point)
    }
  },

  components: {
    Legend,
    Editor: Library.Components.Query.Editor,
    MapperOverview,
    CreateRoute,
    AddStop,
    OptimizeRoute
  }
}
</script>

<style lang="scss">
  .mapper-container {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;

    .gmap-map {
      position: absolute;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;

      .vue-map-hidden {
        display: block;
      }
    }

    .toolbar {
      position: absolute;
      top: 0rem;
      left: 0rem;
      right: 0rem;
      display: flex;
      
      // border-radius: .25rem;
      background: white;
      padding: .5rem;

      > * {
        margin-left: .25rem;
      }
      
      > .toolbar-section > * {
        margin-left: .5rem;
      }
    }

    .message {
      position: absolute;
      left: 1rem;
      bottom: 1rem;
      max-width: 25vw;
    }
  }
</style>
